import React, { FC, ReactElement } from 'react'
import AuthCode from 'react-auth-code-input'
import { StateSetter } from '../../Types/Types'

type Props = {
    className?: string
    setState: StateSetter<Nullable<string>>
}

export const OTPInput: FC<Props> = ({ className, setState }: Props): ReactElement => (
    <AuthCode
        containerClassName={`otp-input-container ${className ?? ''}`}
        inputClassName='otp-input'
        allowedCharacters='numeric'
        onChange={(otpCode: string): void => setState(otpCode)}
    />
)
